import {Async, fromResult, Loaded} from 'Core/models/Async';
import {Email, UnvalidatedEmail, ValidEmail} from 'Core/models/Email';
import {EmptyString, StringUnion} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import unionize, {ofType, UnionOf} from 'unionize';
import { SecurityQuestionByUserNamePayload } from 'Users/models/SecurityQuestionByUserNamePayload';

export enum UsernameRecoveryActionTypes {
  RECOVER_USERNAME = 'usernameRecovery/RECOVER_USERNAME',
  CHANGE_EMAIL = 'usernameRecovery/CHANGE_EMAIL',
  CHANGE_VALIDITY = 'usernameRecovery/VALIDITY',
  INVALID_SECURITY_QUESTIONS = 'usernameRecovery/INVALID_SECURITY_QUESTIONS',
  CLEAR = 'usernameRecovery/CLEAR',
  SECURITY_QUES = 'usernameRecovery/SECURITY_QUES',
}

type RecoveryEmailSubmitted = {};
export const UserEmailRecoveryAddress = unionize({
  email: ofType<Async<Email>>(),
  showSecurityQues: ofType<Loaded<string>>(),
  recoveryEmailSent: ofType<Loaded<RecoveryEmailSubmitted>>(),
});
export type UserEmailRecoveryAddress = UnionOf<typeof UserEmailRecoveryAddress>;

export const recoverUsername = (data: SecurityQuestionByUserNamePayload, email: ValidEmail) =>
  createAction(UsernameRecoveryActionTypes.RECOVER_USERNAME, {data, email});
export const getSecurityQues = (email: ValidEmail) =>
  createAction(UsernameRecoveryActionTypes.SECURITY_QUES, {email});
export const changeEmail = (email: UserEmailRecoveryAddress) =>
  createAction(UsernameRecoveryActionTypes.CHANGE_EMAIL, {email});
export const changevalidity = (valid: boolean) =>
  createAction(UsernameRecoveryActionTypes.CHANGE_VALIDITY, {valid});
export const checkSecurityQuesValidity = (validQues: number) =>
    createAction(UsernameRecoveryActionTypes.INVALID_SECURITY_QUESTIONS, {validQues});
export const clear = () => createAction(UsernameRecoveryActionTypes.CLEAR);

type UsernameRecoveryAction = ReturnType<typeof changeEmail> |
ReturnType<typeof checkSecurityQuesValidity> |
 ReturnType<typeof changevalidity> | 
 ReturnType<typeof clear>;

type UsernameRecoveryState = {
  username: StringUnion;
  email: UserEmailRecoveryAddress;
  valid: boolean;
  validQues: number;
};

export const DEFAULT_STATE: UsernameRecoveryState = {
  username: new EmptyString(),
  email: UserEmailRecoveryAddress.email(fromResult(new UnvalidatedEmail(''))),
  valid: true,
  validQues: 3,
};

export default (state = DEFAULT_STATE, action: UsernameRecoveryAction): UsernameRecoveryState => {
  switch (action.type) {
    case UsernameRecoveryActionTypes.CHANGE_EMAIL:
      return {
        ...state,
        email: action.payload.email,
      };
    case UsernameRecoveryActionTypes.CHANGE_VALIDITY:
      return {
        ...state,
        valid: action.payload.valid,
      };
    case UsernameRecoveryActionTypes.INVALID_SECURITY_QUESTIONS:
        return {
          ...state,
          validQues: action.payload.validQues,
        };
    case UsernameRecoveryActionTypes.CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
